import * as React from "react"

type PublicationSelectorType = {
  selectorString: string
  onClick: () => void
  on: boolean
  count: number
  extraStyle?: string
}

const PublicationSelector = ({
  selectorString,
  onClick,
  on,
  count,
  extraStyle,
}: PublicationSelectorType) => {
  return (
    <button
      type="button"
      aria-pressed={on}
      onClick={onClick}
      className={`filter-chip ${on ? "is-active" : ""} ${extraStyle || ""}`}
    >
      {selectorString === "all publications" ? "all" : selectorString} ·&nbsp;
      {count}
    </button>
  )
}

export default PublicationSelector
